import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FieldAgentClient, DeliveryArea } from 'ep-bt-field-agent-proxy';

@Component({
  selector: 'epbt-fa-deliveryarea-list',
  templateUrl: './epbt-fa-deliveryarea-list.component.html',
  styleUrls: ['./epbt-fa-deliveryarea-list.component.scss']
})
export class EpbtFaDeliveryareaListComponent implements OnInit {

  @Input() deliveryAreas: any;
  @Input() readonly: boolean;


  @Input()
  selectedDeliveryAreaId: DeliveryArea;

  @Output() selectedDeliveryAreaIdChange = new EventEmitter<any>();

  constructor(private client: FieldAgentClient) { }

  ngOnInit(): void {
    this.GetDeliveryArea();
  }

  onSelectionChange(selectedValue: any) {
    this.selectedDeliveryAreaId = selectedValue;
    this.selectedDeliveryAreaIdChange.emit(this.selectedDeliveryAreaId);
  }

  GetDeliveryArea() {
    this.client.getBisTrackActiveDeliveryAreas().subscribe(res => {
      this.deliveryAreas = res;
      if (this.deliveryAreas.length > 0) {
        this.selectedDeliveryAreaId = this.deliveryAreas[0];
        this.selectedDeliveryAreaIdChange.emit(this.deliveryAreas[0]);
      }
    });
  }
}
